import { PIN_LENGTH } from './pinFeatureFlag';

// The same rules the backend applies (PinPolicy), so the user hears about a weak PIN while typing.
// The backend stays the authority and rejects anything this misses.

const isRun = (pin, step) => [...pin].every((digit, i) => i === 0 || digit.charCodeAt(0) - pin.charCodeAt(i - 1) === step);

const repeatsWithPeriod = (pin, period) =>
  pin.length % period === 0 && pin.length !== period && [...pin].every((digit, i) => i < period || digit === pin[i - period]);

const isDoubledDigits = (pin) =>
  pin.length % 2 === 0 && [...pin].every((digit, i) => i % 2 === 1 || digit === pin[i + 1]);

/** The problem with a new PIN, or null when it is acceptable. */
export const pinRuleViolation = (pin, phoneNumber = '', length = PIN_LENGTH) => {
  if (!new RegExp(`^\\d{${length}}$`).test(pin || '')) {
    return `Your PIN must be exactly ${length} digits.`;
  }
  if (repeatsWithPeriod(pin, 1)) {
    return "Don't use the same digit over and over.";
  }
  if (isRun(pin, 1) || isRun(pin, -1)) {
    return "Don't use a run of digits like 123456.";
  }
  if (repeatsWithPeriod(pin, 2) || repeatsWithPeriod(pin, 3)) {
    return "Don't use a repeating pattern like 121212.";
  }
  if (isDoubledDigits(pin)) {
    return "Don't use doubled digits like 112233.";
  }
  const phoneDigits = String(phoneNumber || '').replace(/\D/g, '');
  if (phoneDigits.length >= length && phoneDigits.endsWith(pin)) {
    return "Don't use the last digits of your phone number.";
  }
  return null;
};
